import PolicyTemplate from '../components/o_series/common/PoliciesTemplate'
import s from '../components/o_series/common/Policies.module.css'

const TableHead: React.FC = ({ children }) => (
  <th className="bg-green-200 border-2 text-left text-white px-1 md:px-4 py-2">
    {children}
  </th>
)

const TableBody: React.FC = ({ children }) => (
  <td className="bg-green-50 border-2 border-white text-left px-1 md:px-4 py-2 align-top">
    {children}
  </td>
)

const PrivacyPolicy: React.FC = () => {
  return (
    <PolicyTemplate>
      <div className={`px-1 md:px-0 container mx-auto pb-10 ${s.policy}`}>
        <h3 className="mb-4 font-bold text-lg">Privacy Policy</h3>
        <ol>
          <li className={s.paragraph}>
            This Privacy Policy explains how Nutrameg SIA, registration number:
            50203370651, VAT number: LV50203370651, legal address: Lastadijas
            Street 6, LV-1050, Riga, Latvia (hereinafter – KETO”, “us” “we”)
            processes personal data when providing weight loss and diet services
            (hereinafter – “Service”) and managing website, portal or
            application KetoGo.app (hereinafter – “Site”).
          </li>
          <li className={s.paragraph}>
            Personal data controller is Nutrameg SIA, registration number:
            50203370651, VAT number: LV50203370651, legal address: Lastadijas
            Street 6, LV-1050, Riga, Latvia. E-mail: hello@ketogo.app.
          </li>
          <li>
            <strong>What personal data are we processing?</strong>
          </li>
          <ol>
            <li>
              We process your personal data for multiple purposes, when you
              register for the Service, carry out activities in your profile or
              visit our Site. In certain cases, the processing of your data is
              necessary to provide the Service. But in other cases, if
              processing is not strictly necessary, we will indicate that, for
              example, by giving you the possibility to choose, if you want to
              submit your data to us.
            </li>
            <li>
              The information that you enter, when you do the informative weight
              loss test on our Site, is not stored or otherwise recorded in our
              information systems.
            </li>
            <li>
              To register new Service users, identify the existing users, grant
              you access to your already existing user profile and administer
              your profile, we process your name, surname, email address, phone
              number, gender, age, payment information as well as other data,
              which you have indicated during the registration process.
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Email address, phone number, name, surname, age, gender,
                      type, date and amount of payment for Service, type of
                      Service requested.
                    </TableBody>
                    <TableBody>
                      Processing is necessary for the performance of a contract
                      concluded with you and provide you the Service.
                    </TableBody>
                    <TableBody>
                      Data is retained for as long as you are a registered user
                      of the Service and have paid for the Service. When you
                      delete your profile, we may retain the data, which we are
                      required to keep to fulfill our legal obligations (for
                      example, for tax purposes).
                    </TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              To provide you a personalised Service, prepare a died and
              nutrition plan as well as other tips and suggestions in relation
              to the use of the Service, we process the data you have disclosed
              regarding your eating habits, health status, information on
              pregnancy or breastfeeding as well as other health related data.
              <br />
              <br />
              This information is special category of personal data, thus we
              process it with due care and based on your explicit consent. Your
              health data will only be processed after you have made the payment
              for the Service.
              <br />
              <br />
              Due to the specifics of the Service, we will not be able to
              provide you the Service, if you have not granted the explicit
              consent for the processing of your health data. If you choose not
              to consent, we will make a refund of your payment for the Service.
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Information on your health, smoking habits, pregnancy,
                      breastfeeding, illnesses, medication which you use, diet
                      choices, weight and height.
                    </TableBody>
                    <TableBody>
                      Processing is based n your explicit consent to receive the
                      Service.
                    </TableBody>
                    <TableBody>
                      Data retained for as long as there is a valid consent.
                      When the consent is windrowed, the provision of Service is
                      stopped. If you delete your profile, this data is deleted,
                      if their retention is not required under the applicable
                      laws.
                    </TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              To comply with applicable laws, for example, in relation to
              processing of payments and our accounting obligations, we process
              information that relates to your payments.
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Information on your payments, your place of residence.
                    </TableBody>
                    <TableBody>
                      Processing necessary for compliance with a legal
                      obligation
                    </TableBody>
                    <TableBody>
                      Data retained for as long as required under applicable law
                    </TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              To inform you about news and promotions in relation to the Service
              and send you personalised advertising or other marketing
              communication, we process your name, email address and/or phone
              number. You will only receive such information, if you have
              consented to it when registering for the Service.
              <br />
              <br />
              You have the right to withdraw your consent to receive such
              communication, by clicking on the link in the email footer or by
              writing to our customer support team’s email hello@ketogo.app. In
              case you withdraw your consent by contacting us using the email
              address, we will register this information in your profile within
              2-3 business days.
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Name, surname, email address and/or phone number.
                    </TableBody>
                    <TableBody>
                      Name, surname, email address and/or phone number.
                    </TableBody>
                    <TableBody>
                      Data is retained for as long as there is a valid consent.
                      When consent is withdrawn, we will cease the processing of
                      your data for this purpose.
                    </TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              For the purposes of developing a marketing strategy, client
              segmentation and analysis of our Service, we may process the data
              you have indicated when registering for the Service, for example,
              your gender, the chosen Service as well as certain information
              obtained from{' '}
              <a className="link" href="/cookie-policy">
                cookies
              </a>
              .
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Gender, information from cookies, for example, IP address,
                      device used, type of browser, time and date of opening,
                      unsubscribing and blocking of our emails, clicks,
                      interaction with the Site.
                    </TableBody>
                    <TableBody>
                      Processing necessary for the purposes of our legitimate
                      interests to improve and develop our business.
                    </TableBody>
                    <TableBody>
                      Please see our{' '}
                      <a className="link" href="/cookie-policy">
                        cookie policy
                      </a>
                      , to see more information on our cookies. If you delete
                      your profile, we may retain some of the information in an
                      anonymised and aggregated form.
                    </TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              To provide customer service and resolve any issues that may arise
              in relation to our Service, we process your name, surname, contact
              information, your profile data and any other information that you
              may provide during your communication with our consultants or
              customer service specialists
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Name, surname, e-mail address and/or phone number, profile
                      information, any other information, which may be provided
                      to us during consultation or for purposes stated herein.
                    </TableBody>
                    <TableBody>
                      Processing necessary for the purposes of our legitimate
                      interests to ensure the quality of our Services, solving
                      any problems in relation to it and protection of our legal
                      interests and rights in case of any disputes.
                    </TableBody>
                    <TableBody>
                      Data is retained until the purpose of its processing is
                      achieved or deleted when you delete your profile, if
                      retention is not required to protect our legal rights.
                    </TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              To ensure the protection and security of our database, internal
              systems, the Site and other infrastructure and oversee the use of
              our Service, we may process various technical information, which
              we acquire from{' '}
              <a className="link" href="/cookie-policy">
                cookies
              </a>
              , log files and other similar technological solutions.
              <table className="table-fixed w-full border-collapse mt-6 mb-6">
                <thead>
                  <tr>
                    <TableHead>Personal data category</TableHead>
                    <TableHead>Legal basis for processing</TableHead>
                    <TableHead>Retention period</TableHead>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <TableBody>
                      Your IP address, information on your device, type and
                      version of browser, time zone, various metadata,
                      information on access to the Site and profile, information
                      on interaction with the Site, entry and correction of data
                      and any other information for the purpose set herein.
                    </TableBody>
                    <TableBody>
                      Processing necessary for the purposes of our legitimate
                      interests to ensure the security of our IT system and
                      reliable, continuous, secure business.
                    </TableBody>
                    <TableBody>Data retained for 12 months</TableBody>
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              To estimate, predict and offer you the most appropriate, effective
              diet and nutrition plan, as well as to help you achieve the goal
              you have set, we may collect and analyse (profile) certain types
              of user information. When profiling, we use only accurate, minimal
              data, such as the correlation of user’s weight change due to a
              particular nutrition plan. We perform such profiling based on our
              legitimate interests to provide the most appropriate and efficient
              Service to the user. We do not make automated decisions based on
              profiling that may have legal consequences for you or adversely
              affect you as a data subject. This allows us to offer our users a
              nutrition and diet plan that has been successful for other users
              with similar parameters.
            </li>
          </ol>
          <li>
            <strong>Retention period and data deletion</strong>
          </li>
          <ol>
            <li>
              We will process your personal data for as long as any of the above
              mentioned data processing purposes or legal basis is valid. We
              evaluate the retention period by taking into account our legal
              obligations and retention periods set therein, as well as our
              legitimate interests or your instructions, for example, in case
              you withdraw your consent.
            </li>
            <li>
              When any of the above mentioned data processing purposes or legal
              basis no longer exist, we delete or anonymise the data.
            </li>
          </ol>
          <li>
            <strong>Sharing of your personal data</strong>
          </li>
          <ol>
            <li>
              In certain cases, we cooperate with various third party service
              providers and data processors, who provide support for our
              Service. Thus your personal data may be shared with such service
              providers, who provide hosting and server co-location services,
              e-mail and content delivery services and tools, invoicing and
              payment processing services, marketing, accounting, legal IT and
              other services, which we may reasonably require.
            </li>
            <li>
              Such service providers may only receive the personal data required
              to provide the respective service, for example, the information on
              your payments will only be shared with payment processing service
              providers and only to the extent necessary to secure your payment,
              refund your payment, or review your complaints.
            </li>
            <li>
              Such third party service providers can only process this data in
              accordance with our instructions and are forbidden to use it for
              other purposes. Such service providers are required to ensure
              personal data protection in accordance with the applicable legal
              norms and binding agreements concluded with us. If any of such
              service providers is located outside the EU/ EEA, we ensure that
              the personal data transfer is carried out in accordance with the
              legal requirements and solutions provided in the General Data
              Protection Regulation.
            </li>
            <li>
              We choose and select such service providers with due care and
              require them to ensure the integrity and confidentiality of your
              personal data.
            </li>
            <li>
              Your personal data may be accessed only by authorized KETO
              employees who have agreed to confidentiality obligations and who
              need this information in order to perform their duties.
            </li>
            <li>
              In certain situations, we may be legally required to share your
              information with law enforcement bodies and government
              authorities. We may also share your information with such
              authorities in order to bring, enforce or defend your legal claims
            </li>
            <li>
              KETO as the personal data controller is responsible for the
              processing of your personal data.
            </li>
          </ol>
          <li>
            <strong>Your rights</strong>
          </li>
          <ol>
            <li>
              You have the right to request access to your personal data and
              receive all information we process on you within one month.
            </li>
            <li>
              If you wish to correct your data, you can do it by contacting us
              or correcting it yourself by logging in your profile.
            </li>
            <li>
              If we process your personal data on the basis of our legitimate
              interests, you have the right to object to such processing. If we
              will receive such objection, we will no longer process your
              personal data, unless we can demonstrate compelling legitimate
              grounds for the processing which override the interests, rights
              and freedoms of the data subject or for the establishment,
              exercise or defence of legal claims.
            </li>
            <li>
              You have the right to withdraw your consent for the processing of
              your data, which is based on consent. Revoking of consent will not
              affect the lawfulness of processing based on consent before its
              withdrawal.
            </li>
            <li>
              You have the right to delete your data by logging in your profile
              or contacting us. Please note that we will not be able to delete
              the data, which we are obliged to retain in accordance with
              applicable laws. If you will request deleting your data or object
              to processing of data required to provide you our Service, we will
              not be able to provide you our Service or it will be hindered.
            </li>
            <li>
              If you wish to exercise any of the above-mentioned rights, please
              write to us using the contact information provided herein. Before
              providing any information to you, we may be required to verify
              your identity.
            </li>
            <li>
              If you believe that we have not fulfilled our personal data
              processing obligations or otherwise violated your data protection
              rights, you have the right to submit a complaint to the
              supervisory authority – Data State Inspectorate (Blaumaņa iela
              11/13, Riga, LV-1011, www.dvi.gov.lv).
            </li>
          </ol>
          <li>
            <strong>Contact information</strong>
          </li>
          <ol>
            <li>
              If you have any questions concerning this Privacy Policy or you
              wish to exercise your data subject rights, please contact us by
              writing to hello@ketogo.app
              <br /> <br /> Nutrameg SIA, registration number: 50203370651, VAT
              number: LV50203370651, legal address: Lastadijas Street 6,
              LV-1050, Riga, Latvia
              <br />
            </li>
          </ol>
          <li>
            <strong>Miscellaneous</strong>
          </li>
          <ol>
            <li>
              We reserve the right to change and amend this Privacy Policy from
              time to time. The amendments take effect as soon as they are
              uploaded to the Site. In the event of a material change, we will
              notify you, for example, by posting a notice on your profile, on
              the Site or by sending you an email.
            </li>
          </ol>
        </ol>
        <p className="mt-4 text-right text-lg">
          This Privacy Policy is effective as of 22.04.2021
        </p>
      </div>
    </PolicyTemplate>
  )
}

export default PrivacyPolicy
